export default defineAppConfig({
  ui: {
    colors: {
      primary: 'green',
    },
    navigationMenu: {
      slots: {
        link: 'gap-3 mb-2',
        linkLeadingIcon: 'size-4.5',
      },
      variants: {
        active: {
          true: {
            link: 'text-primary',
          },
          false: {
            linkLeadingIcon: 'text-gray-600',
            link: 'text-gray-600',
          },
        },
        disabled: {
          true: {
            link: 'hidden',
          },
        },
      },
      compoundVariants: [
        {
          contentOrientation: 'vertical',
          collapsed: true,
          variant: 'link',
          class: {
            link: 'flex items-center justify-center bg-black',
          },
        },
      ],
    },
    badge: {
      variants: {
        size: {
          md: {
            base: 'gap-2',
            leadingIcon: 'size-3.5',
          },
        },
      },
    },
    button: {
      slots: {
        base: 'cursor-pointer',
      },
      variants: {
        size: {
          sm: {
            base: 'gap-2',
          },
        },
      },
    },
    radioGroup: {
      variants: {
        variant: {
          card: {
            item: 'bg-white border border-gray-200',
          },
        },
        disabled: {
          false: {
            item: 'hover:cursor-pointer',
          },
        },
      },
    },
    checkbox: {
      variants: {
        variant: {
          card: {
            label: 'font-medium',
          },
        },
      },
    },
    tooltip: {
      slots: {
        text: '',
      },
    },
    alert: {
      slots: {
        title: 'font-semibold',
      },
      compoundVariants: [
        {
          color: 'secondary',
          variant: 'subtle',
          class: {
            root: 'bg-secondary-50 text-secondary-600',
          },
        },
      ],
    },
    formField: {
      slots: {
        label: 'text-sm font-semibold text-gray-600',
        description: 'mb-3 text-xs text-gray-500',
      },
    },
  },
});
